import { defineComponent, h } from 'vue';
import { QCard, QCardSection } from 'quasar';
import BaseFieldsetComponent from './baseFieldsetMixin.jsx';

import TranslationContainer from '../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-fieldset',
    mixins: [BaseFieldsetComponent],
    components: {
        QCard,
        QCardSection,
        TranslationContainer
    },
    data: () => ({
    }),
    props: {
        //nopadding: false,
        columns: null,
        /** Optional CSS grid-template-columns; when set, overrides equal-width columns. */
        gridTemplateColumns: null,
    },
    created() {
    },
    methods: {
        // Coerce the column prop to a safe positive integer so layout math is predictable.
        normalizeColumns(columns) {
            const parsed = Number(columns);
            if (!Number.isFinite(parsed))
                return 1;

            return Math.max(1, Math.floor(parsed));
        },
        // Render a responsive grid wrapper when multiple columns are requested; otherwise keep original markup.
        buildFieldsetBody(elements, normalizedColumns) {
            const customTemplate = typeof this.gridTemplateColumns === 'string'
                && this.gridTemplateColumns.trim()
                ? this.gridTemplateColumns.trim()
                : null;

            if (normalizedColumns <= 1 && !customTemplate)
                return elements;

            const gridStyle = {
                display: 'grid',
                gridTemplateColumns: customTemplate
                    || `repeat(${Math.max(normalizedColumns, 2)}, minmax(0, 1fr))`,
                columnGap: '10px',
                rowGap: '10px',
                alignItems: 'start'
            };

            const cells = elements.map((element, index) => (
                <div key={element?.key || `fieldset-cell-${index}`} class="sform-fieldset-grid-cell">
                    {element}
                </div>
            ));

            return (
                <div class="sform-fieldset-grid" style={gridStyle}>
                    {cells}
                </div>
            );
        },
        isPassthroughWrapper() {
            if (!this.form || this.form.length !== 1)
                return false;

            const type = this.form[0]?.type?.toLowerCase();
            return type === 'fieldset' || type === 'section' || type === 'conditional' || type === 'tabs';
        },
        shouldAddTopSpacing(isStandaloneFieldset) {
            return isStandaloneFieldset
                && this.hasVisibleFieldsetTitle()
                && !this.nestedInTitledFieldset
                && !this.isPassthroughWrapper();
        }
    },
    render() {
        if (!this.form)
            return null;

        const elements = this.generateElements(h, this.form, this.layouttype);
        const normalizedColumns = this.normalizeColumns(this.columns);
        const fieldsetBody = this.buildFieldsetBody(elements, normalizedColumns);
        const isArrayItemFieldset = this.isArrayItem || this.type === 'FormField_ArrayItem';
        const isStandaloneFieldset = this.element?.type === 'fieldset' && !isArrayItemFieldset;
        const shouldAddTopSpacing = this.shouldAddTopSpacing(isStandaloneFieldset);

        let cardClass;
        if (this.nopadding)
            cardClass = { 'q-pa-none': true };
        else
            cardClass = {
                'q-pb-xs': true,
                'q-pt-sm': true,
                'q-pl-sm': true,
                'q-pr-sm': true
            };

        switch (this.layouttype) {
            case 'sform-card-layout':
                {
                    let title;
                    if (this.element && this.Title && !this.element.notitle && !this.notitle)
                        title = (
                            <QCardSection class={[cardClass, 'text-h6', 'text-black']}>
                                <TranslationContainer context={this} value={this.Title}/>
                            </QCardSection>
                        );

                    return (
                        <QCard
                            flat
                            style={{ flexGrow: 1, paddingTop: shouldAddTopSpacing ? '32px' : undefined }}
                            class="c-sform-card-layout c-qcard"
                        >
                            {title}
                            <QCardSection class={{ ...cardClass, 'c-sform-card-layout': true, 'c-qcard': true, 'c-qcardsection': true }} style="flex-direction: column;">
                                {fieldsetBody}
                            </QCardSection>
                        </QCard>
                    );
                }
            case 'sform-table-layout':
            default:
                {
                    let title;
                    if (this.element && this.Title && !this.element.notitle)
                        title = (
                            <tr>
                                <td colspan="2">
                                    <h3 style="border-bottom: 1px solid #e5e5e5;">{this.Title}</h3>
                                </td>
                            </tr>
                        );

                    return (
                        <table width="100%">
                            {title}
                            {elements}
                        </table>
                    );
                }
        }
    }
});